import React, { createContext, useState, useContext, useEffect } from "react";

export const useScroll = () => {
  return useContext(ScrollContext);
};

export const ScrollContext = createContext({
  scroll: 0,
  setScroll: () => {},
  mobile: false,
  setMobile: () => {},
});

const ScrollProvider = (props) => {
  const [scroll, setScroll] = useState(0);
  const [mobile, setMobile] = useState(false);
  useEffect(() => {
    window.onscroll = function () {
      // Obtenemos la posicion del scroll en pantall
      const scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      setScroll(scroll);
    };
  }, [scroll]);

  useEffect(() => {
    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      setMobile(true);
    }
  }, []);

  return (
    <ScrollContext.Provider value={{ scroll, setScroll, mobile }}>
      {props?.children}
    </ScrollContext.Provider>
  );
};

export default ScrollProvider;
